import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import SugarcubeContext from 'apps/SugarcubeContext'
import Icon from 'components/uiElements/Icon'
import { compositionDataItemsType, trackingRoomInfoType } from 'models/propTypes'
import { click } from 'utils/tracker'
import Thumbnail from 'components/dashboard/Thumbnail'
import { ROOM_SOURCE_STOCK } from 'models/tracking/constants'

require('./OpenCompositionModal.scss')

const OpenCompositionModal = ({ closeTryNewRoomModal, compositionDataItems, openComposition, roomInfo }) => {
    const { t } = useTranslation()
    const { isMagicWindow } = useContext(SugarcubeContext)
    const openNewComposition = (composition) => {
        const { name, id, sceneId } = composition
        const newRoomInfo = {
            RoomId: sceneId,
            RoomTitle: name,
            RoomSource: ROOM_SOURCE_STOCK,
        }
        click('DecorateRoom.TryNewRoom.Open', newRoomInfo)
        openComposition(id)
        closeTryNewRoomModal()
    }

    const onCancel = () => {
        click('DecorateRoom.TryNewRoom.Cancel', roomInfo)
        closeTryNewRoomModal()
    }

    return (
        <div className="OpenCompositionModal">
            <div className="modalHeader">
                {isMagicWindow ? (
                    <Icon svg code="logo_ikea" className="logoHome" />
                ) : (
                    <Icon svg code="logo_sugarcube_bug_ikea" className="logoHome" />
                )}
                <button onClick={onCancel} className="cancelButton">
                    {t('design.cancel')}
                </button>
            </div>
            <div className="modalBodyContainer">
                <div className="modalBody">
                    <div className="modalBodyHeader">{t('design.select a new room')}</div>
                    <div className="modalBodySubheader">{t('design.replace and rearrange')}</div>
                    {compositionDataItems.map((composition) => {
                        const compNoCreationDate = { ...composition, creationDate: undefined }
                        return (
                            <Thumbnail
                                key={composition.id}
                                onClick={() => openNewComposition(composition)}
                                item={compNoCreationDate}
                                cta={t('dashboard.compositionOpenCTA')}
                                data-testid="stock-compositions"
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

OpenCompositionModal.defaultProps = {
    compositionDataItems: null,
    roomInfo: null,
}

OpenCompositionModal.propTypes = {
    closeTryNewRoomModal: func.isRequired,
    compositionDataItems: compositionDataItemsType,
    openComposition: func.isRequired,
    roomInfo: trackingRoomInfoType,
}

export default OpenCompositionModal
